/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WbsPlanningInputDtoFromJSON, WbsPlanningInputDtoToJSON, } from './WbsPlanningInputDto';
/**
 * Check if a given object implements the WbsInputListDto interface.
 */
export function instanceOfWbsInputListDto(value) {
    return true;
}
export function WbsInputListDtoFromJSON(json) {
    return WbsInputListDtoFromJSONTyped(json, false);
}
export function WbsInputListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'titolo': json['titolo'] == null ? undefined : json['titolo'],
        'pesoAttivita': json['pesoAttivita'] == null ? undefined : json['pesoAttivita'],
        'corrispettivoEconomico': json['corrispettivoEconomico'] == null ? undefined : json['corrispettivoEconomico'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'wbsPlanningInputDtoList': json['wbsPlanningInputDtoList'] == null ? undefined : (json['wbsPlanningInputDtoList'].map(WbsPlanningInputDtoFromJSON)),
    };
}
export function WbsInputListDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'titolo': value['titolo'],
        'pesoAttivita': value['pesoAttivita'],
        'corrispettivoEconomico': value['corrispettivoEconomico'],
        'projectId': value['projectId'],
        'wbsPlanningInputDtoList': value['wbsPlanningInputDtoList'] == null ? undefined : (value['wbsPlanningInputDtoList'].map(WbsPlanningInputDtoToJSON)),
    };
}
